import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'collections/:collectionId',
    pathMatch: 'full',
    loadChildren: () => import('./show/show.module').then((module) => module.ShowModule),
  },
  {
    path: 'collections/:collectionId/preview/:sourceAssetId',
    pathMatch: 'full',
    loadChildren: () => import('./previewer/collection-previewer.module').then(
      (module) => module.CollectionPreviewerModule,
    ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CollectionRoutingModule {}
